import httpClient from '@/apis/base/httpclient';
import DashboardApi from './_dashboardApi';

class DashboardReceivableDebtAPI extends DashboardApi {
  constructor() {
    super();
  }
  controllerName = 'Dashboards';

  /**
   * Hàm lấy dữ liệu biểu đồ
   * @returns
   * TVANH 20.06.2023
   */
  async getChartData(param) {
    let apiUrl = this.getAPIUrl();
    let result = [];

    let request = {
      url: apiUrl + '/DataChart',
      data: param,
    };

    await httpClient.postAsync(request).then(res => {
      result = res;
    });

    return result;
  }

  /**
   * Lấy thông tin biểu đồ theo id
   * @param {} param
   * @returns
   */
  async getChartDataById(param) {
    let request = {
      url: this.getAPIUrl() + '/DataChartById',
      data: param,
    };
    return await httpClient.getAsync(request);
  }
}

export default new DashboardReceivableDebtAPI();
